export default "__VITE_ASSET__BIAib$_3__"